import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Divider,
  Button,
  IconButton,
  Tooltip,
  useMediaQuery,
  Breadcrumbs,
  LinearProgress,
  CircularProgress,
} from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Cell,
  Legend,
} from "recharts";
import GaugeChart from "react-gauge-chart";
import { PDFDownloadLink } from "@react-pdf/renderer";
import Certificate from "./Pdf/Certificate";
import { useLocation, useNavigate } from "react-router-dom";
import { useProSidebar } from "react-pro-sidebar";
import Swal from "sweetalert2";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { ResponsiveContainer } from "recharts";
import Chart from "react-apexcharts"; // ✅ ApexCharts import
import { ScoredashBoard } from "../../store/reducers/LoginReducer";
import { useDispatch, useSelector } from "react-redux";
import { BlobProvider } from "@react-pdf/renderer";
import { getConfig } from "../../config";

const EmpAssessmentDashboard = () => {
  // Sample chart data
  const [chartData] = useState([
    { name: "Q1", score: 1 },
    { name: "Q2", score: 0 },
    { name: "Q3", score: 1 },
    { name: "Q4", score: 1 },
    { name: "Q5", score: 0 },
  ]);

  // Calculate percentage for gauge
  const total = chartData.length;
  const correct = chartData.filter((x) => x.score === 1).length;
  const percent = correct / total;
  const dispatch = useDispatch();

  const location = useLocation();
  const state = location.state || {};
  const empID = state.EmployeeID || 0;

  //STATE PASSING
  const AssessmentName = state.AssessmentName;
  const AssessmentID = state.AssessmentID;
  const ScheduleID = state.ScheduleID;
  const Lastattdate = state.Lastattdate;
  const Firstattdate = state.Firstattdate;
  const NoofAttemp = state.NoofAttemp;
  const BreadCrumb1 = state.BreadCrumb1;
  const BreadCrumb2 = state.BreadCrumb2;
  console.log("🚀 ~ AssessmentDashboard ~ BreadCrumb2:", BreadCrumb2)
  console.log("🚀 ~ AssessmentDashboard ~ BreadCrumb1:", BreadCrumb1)
  //const Lastattscore = Number(state.Lastattscore) / 100;

  const EmployeeName = state.EmployeeName;

  const { toggleSidebar, broken, rtl } = useProSidebar();
  const navigate = useNavigate();

  const isNonMobile = useMediaQuery("(min-width:600px)");
  useEffect(() => {
    // dispatch(dashBoardTask({ data: { EmployeeID: empID } }));
    dispatch(
      ScoredashBoard({
        data: { EmployeeID: empID, AssessmentID: AssessmentID, ScheduleID:ScheduleID },
      })
    );
  }, [location.key]);

  const ScoredashBoardGetData = useSelector(
    (state) => state.loginApi.ScoredashBoardGetData
  );
  // SCORE
  const rawScore = ScoredashBoardGetData?.details?.LastAttemptScore
    ? parseFloat(ScoredashBoardGetData.details.LastAttemptScore)
    : null;
  console.log("🚀 ~ AssessmentDashboard ~ rawScore:", rawScore)

  const Lastattscore = rawScore !== null ? rawScore / 100 : 0;
  console.log("🚀 ~ AssessmentDashboard ~ Lastattscore:", Lastattscore)

  // const series =
  //   ScoredashBoardGetData?.yaxis?.map((item) => ({
  //     name: item.name,
  //     data: item.Score, // ✅ ApexCharts expects "data", not "Score"
  //   })) || [];

  const series = [
    {
      name: ScoredashBoardGetData?.yaxis?.[0]?.name,
      data: ScoredashBoardGetData?.yaxis?.[0]?.Score || [],
    },
  ];

  console.log("🚀 ~ AssessmentDashboard ~ YaxisFilter:", series);
  console.log(ScoredashBoardGetData, "dataaaaaaaaaaaaaaaa...");
  // After you have series populated from API
  const attemptLength = series[0]?.data?.length || 0;
  // const colors =
  //   attemptLength > 0
  //     ? Array.from({ length: attemptLength }, (_, i) =>
  //         i === attemptLength - 1 ? "green" : "red"
  //       )
  //     : [];
  const colors =
    attemptLength > 0
      ? Array.from({ length: attemptLength }, (_, i) =>
          i === attemptLength - 1 ? "#43A047" : "#E53935"
        )
      : [];

  const ScoredashBoardGetStaus = useSelector(
    (state) => state.loginApi.ScoredashBoardGetStaus
  );
  console.log(
    "🚀 ~ AssessmentDashboard ~ ScoredashBoardGetStaus:",
    ScoredashBoardGetStaus
  );

  const ScoredashBoardGetLoading = useSelector(
    (state) => state.loginApi.ScoredashBoardGetLoading
  );
  const ScoredashBoardGetError = useSelector(
    (state) => state.loginApi.ScoredashBoardGetError
  );
  console.log(
    "🚀 ~ AssessmentDashboard ~ ScoredashBoardGetError:",
    ScoredashBoardGetError
  );
  const fnLogOut = (props) => {
    Swal.fire({
      title: `Do you want ${props}?`,
      // text:data.payload.Msg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          navigate("/Apps/TR026/Department");
        }
      } else {
        return;
      }
    });
  };
  //LOADING
  const getLoading = useSelector((state) => state.formApi.getLoading);

  const barChartOptions = {
    chart: {
      toolbar: { show: false },
    },
    xaxis: {
      categories: ["13/09/2025", "15/09/2025"], // Dates on X axis
    },
    tooltip: {
      x: {
        formatter: function (val, opts) {
          const labels = ["First Attempt", "Second Attempt"];
          return labels[opts.dataPointIndex] || "Attempt";
        },
      },
    },
    colors: ["#42a5f5", "#40DB9C"],
    plotOptions: {
      bar: {
        borderRadius: 6,
        columnWidth: "20%",
        distributed: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
  };

  const barChartSeries = [
    {
      name: "Attempt Score",
      data: [10, 15], // Scores for each attempt
    },
  ];
  const HeaderImg = sessionStorage.getItem("CompanyHeader");
  const FooterImg = sessionStorage.getItem("CompanyFooter");
  const CompanySignature = sessionStorage.getItem("CompanySignature");
  console.log("🚀 ~ AssessmentDashboard ~ CompanySignature:", CompanySignature)

  const config = getConfig();
  const baseurl1 = config.UAAM_URL;
  return (
    <Box
      sx={{
        p: 2,
        height: "100vh",
      }}
    >
      <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0" }}>
        <Box display="flex" justifyContent="space-between" p={2}>
          <Box display="flex" borderRadius="3px" alignItems="center">
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Box
              display={isNonMobile ? "flex" : "none"}
              borderRadius="3px"
              alignItems="center"
            >
              <Breadcrumbs
                maxItems={3}
                aria-label="breadcrumb"
                separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
              >
                <Typography
                  variant="h5"
                  color="#0000D1"
                  sx={{ cursor: "default" }}
                  onClick={() => navigate("/Apps/TR308/List%20Of%20Assessment%20Type")}
                >
                  List Of Assessment Type ({state.BreadCrumb1})
                </Typography>
                <Typography
                  variant="h5"
                  color="#0000D1"
                  sx={{ cursor: "default" }}
                  onClick={() => navigate(-1)}
                >
                  {/* List Of Assessment ({AssessmentName}) */}
                  List Of Assessment (
                  {ScoredashBoardGetData?.details?.AssessmentName})
                </Typography>

                <Typography
                  variant="h5"
                  color="#0000D1"
                  sx={{ cursor: "default" }}
                >
                  Assessment Dashboard
                </Typography>
              </Breadcrumbs>
            </Box>
          </Box>

          <Box display="flex">
            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton color="error" onClick={() => fnLogOut("Logout")}>
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>

      {ScoredashBoardGetLoading ? (
        <LinearProgress />
      ) : (
        <>
          <Paper elevation={3} sx={{ margin: "10px", padding: "20px" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Typography variant="h4" gutterBottom>
                  Assessment Dashboard ({EmployeeName || ""})
                </Typography>
              </Box>

              {/* Example Button */}

              <Box>
                {/* PDF BUTTON */}
                <Box>
                  <PDFDownloadLink
                    document={
                      <Certificate
                        AssessmentName={
                          ScoredashBoardGetData?.details?.AssessmentName
                        }
                        EmpName={ScoredashBoardGetData?.details?.EmpName}
                        IssueDate={
                          ScoredashBoardGetData?.details?.LastDateAttempt
                        }
                          baseurl={baseurl1}
                        HeaderImg={HeaderImg}
                        FooterImg={FooterImg}
                        CompanySignature={CompanySignature}
                        
                      />
                    }
                    fileName="certificate.pdf"
                    style={{ textDecoration: "none" }}
                  >
                    {({ loading }) => (
                      <Button variant="contained" color="primary">
                        {loading ? (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <span>Preparing Certificate</span>

                            <CircularProgress
                              size={20}
                              sx={{ color: "white" }}
                            />
                          </Box>
                        ) : (
                          "Download Certificate"
                        )}
                      </Button>
                    )}
                  </PDFDownloadLink>
                </Box>
              </Box>
            </Box>
            <Divider sx={{ my: 2 }} />

            {/* Charts Row */}
            <Box
              sx={{
                display: "flex",
                //justifyContent: "space-around",
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
              {/* Gauge Chart */}
              <Box
                //sx={{ width: 300 }}
                sx={{
                  flex: { xs: "100%", md: "60%" },
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <GaugeChart
                  id="gauge-chart1"
                  nrOfLevels={10}
                  percent={Lastattscore}
                  textColor="#000"
                  colors={["#e53935", "#43a047"]}
                  needleColor="#000"
                  style={{
                    width: "100%", // responsive width
                    maxWidth: "350px", // cap the maximum size
                    height: "auto",
                  }}
                />
              </Box>
              <Box
                sx={{
                  flex: { xs: "100%", md: "40%" },
                  pl: { md: 3, xs: 0 },
                  display: "flex",
                  flexDirection: "column",
                  alignItems: { md: "flex-start", xs: "center" },
                }}
              >
                <Typography variant="h5" gutterBottom>
                  Assessment Title:{" "}
                  <b>{ScoredashBoardGetData?.details?.AssessmentName}</b>
                </Typography>
                <Typography variant="h5" gutterBottom>
                  {/* Score: <b>{Lastattscore * 100}</b> */}
                  Score: <b>{rawScore }</b>
                </Typography>
                <Typography variant="h5" gutterBottom>
                  First Attempt Date:{" "}
                  <b>{ScoredashBoardGetData?.details?.FirstDateAttempt}</b>
                </Typography>
                <Typography variant="h5" gutterBottom>
                  Last Attempt Date:{" "}
                  <b>{ScoredashBoardGetData?.details?.LastDateAttempt}</b>
                </Typography>
              </Box>
            </Box>

            {/* <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box>
          
          </Box>

          <Box>
           
          </Box>
        </Box> */}
            <Divider sx={{ my: 3 }} />
          </Paper>

          <Paper elevation={3} sx={{ margin: "10px", padding: "20px" }}>
            <Box sx={{ width: "100%" }}>
              <Typography variant="h4" gutterBottom>
                Assessment Progress (Max Attempts:
                {ScoredashBoardGetData?.details?.MaxNoOfAttempt})
              </Typography>
              {/* <Chart
            type="bar"
            height={300}
            //  options={ScoredashBoardGetData.ScoreChart.xaxis}
           
            // series={ScoredashBoardGetData.ScoreChart.yaxis.Score}
            options={barChartOptions}
            series={barChartSeries}
          /> */}
              {/* {(ScoredashBoardGetStaus === "fulfilled" && !ScoredashBoardGetError) && ( */}
              <Chart
                type="bar"
                height={300}
                //width={"80%"}
                options={{
                  chart: { toolbar: { show: false } },
                  xaxis: {
                    categories: ScoredashBoardGetData.xaxis, // ✅ Dates from API
                  },
                  yaxis: {
                    min: 0,
                    max: 100, // ✅ Fix maximum to 100
                    tickAmount: 5, // ✅ Gives 6 ticks (0,20,40,60,80,100)
                    labels: {
                      formatter: (val) => `${val}`, // Optional: format labels
                    },
                  },
                  plotOptions: {
                    bar: {
                      borderRadius: 6,
                      columnWidth: "30%",
                      distributed: true,
                    },
                  },
                  legend: {
                    show: false, // Disable automatic legend
                  },
                  dataLabels: { enabled: false },
                  colors: colors,
                }}
                series={series} // ✅ Correct series format
              />
              {/* )} */}
              <Box display="flex" alignItems="center" justifyContent="center" mt={2} gap={2}>
                
                <Box display="flex" alignItems="center" gap={1}>
                  <Box
                    sx={{
                      width: 16,
                      height: 16,
                      background: "#E53935",
                      borderRadius: "2px",
                      display: "inline-block",
                    }}
                  />
                  <Typography>Fail</Typography>
                </Box>
                <Box display="flex" alignItems="center" gap={1}>
                  <Box
                    sx={{
                      width: 16,
                      height: 16,
                      background: "#43A047",
                      borderRadius: "2px",
                      display: "inline-block",
                    }}
                  />
                  <Typography>Pass</Typography>
                </Box>
              </Box>
            </Box>
          </Paper>
        </>
      )}
    </Box>
  );
};

export default EmpAssessmentDashboard;
